import DelBox from "../comps/DelBox";
import NewSupplier1 from "../models/NewSupplier1";
import { useEffect, useState } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";
function Suppliers() {
    const [formData, setFormData] = useState({
        l1: [],
        cat_type: 'supplier1',
        search_key: '',
        page_no: 0,
        alertMsg: '',
        alertMsgTyp: '',
        isAlert: false,
    });
    const [isAdmin , setIsAdmin] = useState('')
    const [ldata, setLdata] = useState(null);
    const [editItem, setEditItem] = useState(null);
    const initData = async () => {
        const storedData = sessionStorage.getItem("ldata");
          const userData = JSON.parse(sessionStorage.getItem("ldata"));
  const roleId = userData?.role_id;
    if (roleId === 1 || roleId === "1") {
      setIsAdmin(true);
    } else {
      setIsAdmin(false);
    }
        if (storedData) {
            const parsed = JSON.parse(storedData);
            const fd = new FormData();
            fd.append('type', formData.cat_type + "");
            fd.append('search_key', formData.search_key + "");
            fd.append('page_no', formData.page_no + "");
            fd.append('user_cre_by', 1 + "");
            try {
                const response = await axios.post(AppConst.BASE_URL + AppConst.getUserListUrl, fd, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                if (response.data.status) {

                    var records = response.data.records;
                    if (records != null && records != undefined) {
                        setFormData(prev => ({
                            ...prev,
                            l1: records
                        }));
                    }
                }
            } catch (error) {

            }
        }
    };
    const handleChange = (e) => {

        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const delItem = async (editItem) => {
        const fd = new FormData();
        fd.append('user_id', editItem.user_id + "");
        try {
            const response = await axios.post(AppConst.BASE_URL + AppConst.delUserUrl, fd, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            if (response.data.status) {
                initData();
            }
        } catch (error) {

        }
    };

    const handleAddDepart = () => {
        formData.page_no = 0;
        initData();
    };

    useEffect(() => {
        console.log('Component mounted');
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);
            setLdata(parsed);
            initData();
        }

        return () => {
            console.log('Component unmounted');
        };
    }, []);

     const filteredList = formData.search_key.trim() === ""
  ? formData.l1
  : formData.l1.filter(item =>
      (`${item.mobile}`.toLowerCase().includes(formData.search_key.toLowerCase()) ||
      `${item.fname}`.toLowerCase().includes(formData.search_key.toLowerCase()))
    );
    return (
        <div class="page-content">
            <div class="container-fluid">


                <div class="row">
                    <div class="col-lg-12">
                        <div class="card" id="orderList">
                            <div class="card-header border-0">
                                <div class="row align-items-center gy-3">
                                    <div class="col-sm">
                                        <h5 class="card-title mb-0">Suppliers</h5>
                                    </div>
                                    <div class="col-sm-auto">
                                        <div class="d-flex gap-1 flex-wrap">
                                            <button id="addbt453" style={{ display: "none" }} type="button" class="btn btn-success add-btn"
                                                data-bs-toggle="modal" data-bs-target="#showModal" fdprocessedid="jys8hw">
                                            </button>
                                            <button type="button" class="btn btn-success add-btn"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    setEditItem(null);
                                                    document.getElementById("addbt453").click();
                                                }}
                                            ><i class="ri-add-line align-bottom me-1"></i> Add Supplier </button>
                                            <button class="btn btn-soft-danger" id="remove-actions">
                                                <i class="ri-delete-bin-2-line"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body border border-dashed border-end-0 border-start-0">
                                <form>
                                    <div class="row g-3">
                                        <div class="col-xxl-4 col-sm-6">
                                            <div class="search-box">
                                                <input type="text" class="form-control search"
                                                    name="search_key" onChange={handleChange} value={formData.search_key}
                                                    placeholder="Search name..." />
                                                <i class="ri-search-line search-icon"></i>
                                            </div>
                                        </div>
                                        {/* <div class="col-xxl-2 col-sm-4">
                                            <div>
                                                <select class="form-control" data-choices="" data-choices-search-false="" name="choices-single-default" id="idStatus">
                                                    <option value="all" selected="">All Purchases</option>
                                                    <option value="Pending">Purchase</option>
                                                    <option value="Completed">Purchase Return</option>
                                                </select>
                                            </div>
                                        </div> */}
                                    </div>
                                    {/* <!--end row--> */}
                                </form>
                            </div>
                            <br />
                            <div class="card-body pt-0">
                                <div>

                                    <div class="table-responsive table-card mb-1">
                                        <table class="table table-nowrap align-middle" id="orderTable">
                                            <thead class="text-muted table-light" >
                                                <tr class="text-uppercase">
                                                    <th scope="col">
                                                        <div class="form-check">
                                                            <input class="form-check-input" type="checkbox" id="checkAll" value="option" />
                                                        </div>
                                                    </th>
                                                    <th data-sort="customer_name">Sr. N.</th>
                                                    <th data-sort="customer_name">Name</th>
                                                    <th data-sort="customer_name">Contact</th>
                                                    <th data-sort="customer_name">Address</th>
                                                    <th data-sort="customer_name">GSTIN</th>
                                                    <th data-sort="customer_name">DLNO</th>
                                                    <th data-sort="city">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody class="list form-check-all">
                                                {filteredList.map((item, index) => (
                                                    <tr>
                                                        <th scope="row">
                                                            <div class="form-check">
                                                                <input class="form-check-input" type="checkbox" name="checkAll" value="option1" />
                                                            </div>
                                                        </th>
                                                        <td class="customer_name">{index + 1}.</td>
                                                        <td class="customer_name">{item.fname}</td>
                                                        <td class="customer_name"> {item.mobile}</td>
                                                        <td class="customer_name">{item.address_line1}, {item.address_line2},{item.city}, {item.pincode}</td>
                                                        <td class="customer_name">{item.gstin}</td>
                                                        <td class="customer_name">{item.dlno}</td>

                                                        <td>
                                                            <ul class="list-inline hstack gap-2 mb-0">
                                                                     <li className="list-inline-item edit" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" aria-label="Edit" data-bs-original-title="Edit">
                                <button
                                  type="button"
                                  className="btn btn-sm btn-outline-primary d-inline-flex align-items-center edit-item-btn"
                                       disabled={!isAdmin} // ❌ normal user ke liye disable
                                                         style={{ opacity: !isAdmin ? 0.5 : 1, pointerEvents: !isAdmin ? "none" : "auto" }}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setEditItem(item);
                                    document.getElementById("addbt453").click();
                                  }}
                                >
                                  <i className="ri-pencil-fill fs-16 me-1"></i> Edit
                                </button>
                              </li>

                              {/* DELETE BUTTON */}
                              <li className="list-inline-item" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" aria-label="Remove" data-bs-original-title="Remove">
                                <button
                                  type="button"
                                       disabled={!isAdmin} // ❌ normal user ke liye disable
                                                         style={{ opacity: !isAdmin ? 0.5 : 1, pointerEvents: !isAdmin ? "none" : "auto" }}
                                  className="btn btn-sm btn-outline-danger d-inline-flex align-items-center remove-item-btn"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    delItem(item);
                                  }}
                                >
                                  <i className="ri-delete-bin-5-fill fs-16 me-1"></i> Delete
                                </button>
                              </li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                        {/* <div class="noresult">
                                            <div class="text-center">
                                                <lord-icon src="https://cdn.lordicon.com/msoeawqm.json" trigger="loop" colors="primary:#405189,secondary:#0ab39c"></lord-icon>
                                                <h5 class="mt-2">Sorry! No Result Found</h5>
                                                <p class="text-muted">We've searched more than 150+ Orders We did not find any orders for you search.</p>
                                            </div>
                                        </div> */}
                                    </div>
                                    <div class="pagination-wrap hstack gap-2 flex justify-content-end">
                                        <a class="page-item pagination-prev disabled" href="javascript:void(0)"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                if (formData.page_no > 0) {
                                                    formData.page_no--;
                                                    initData();
                                                }
                                            }}
                                        >Previous</a>
                                        <ul class="pagination listjs-pagination mb-0"></ul>
                                        <a class="page-item pagination-next" href="javascript:void(0)"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                formData.page_no++;
                                                initData();
                                            }}
                                        >Next</a>
                                    </div>
                                </div>
                                <NewSupplier1 item={editItem} onAddDepart={handleAddDepart} />
                                <DelBox />
                            </div>
                        </div>

                    </div>
                    {/* <!--end col--> */}
                </div>
                {/* <!--end row--> */}

            </div>
            {/* <!-- container-fluid --> */}
        </div>
    );
}

export default Suppliers;
